"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chart = void 0;
var react_1 = require("@okay/okaychart/dist/src/react");
var React = require("react");
var getLineChart_1 = require("@/pages/common/transformers/getLineChart");
var getLineBarChart_1 = require("@/pages/common/transformers/getLineBarChart");
var getBarChart_1 = require("@/pages/common/transformers/getBarChart");
var getStackChart_1 = require("@/pages/common/transformers/getStackChart");
var chart = function (props) {
    var config;
    var hasCount = props.yCounts && props.yCounts.length && props.yCounts[0] && props.yCounts[0].length;
    if (hasCount) {
        config = getLineBarChart_1.getLineBarChart(props, props.isMobile);
    }
    else {
        if (props.useBar) {
            if (props.yValues.length === 1) {
                config = getBarChart_1.getBarChart(props);
            }
            else {
                config = getStackChart_1.getStackChart(props);
            }
        }
        else {
            config = getLineChart_1.getLineChart(props);
        }
    }
    return (React.createElement("div", { className: "c-estate__chart-view-container", key: props.id },
        React.createElement(react_1.ChartWithPopup, { config: config, onSelected: props.onSelected })));
};
exports.chart = chart;
